import React from "react";
import SlidingIconButton from "./SlidingIconButton";

interface ClosePickerButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const ClosePickerButton: React.FC<ClosePickerButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <SlidingIconButton
      color="text-white"
      text="Stoppen"
      iconClass="d-close"
      className="hover:w-[6.4rem] hover:border-sunshineYellow"
      onClick={onClick}
      reverse={false}
      disabled={disabled}
    />
  );
};

export default ClosePickerButton;
